"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeekNumberingYearTwoDigit = exports.getWeekNumberingYearNumeric = exports.getYearTwoDigit = exports.getYearNumeric = void 0;
var get_iso_week_values_1 = require("../utils/get-iso-week-values");
var pad_number_to_length_1 = require("../utils/pad-number-to-length");
/**
 * Returns a numerical representation of the year: 0, 1, 2, ..., 1900, 1901, ..., 2099
 * @hidden
 */
var getYearNumeric = function (_a) {
    var offsetUtcDate = _a.offsetUtcDate;
    return offsetUtcDate.getUTCFullYear();
};
exports.getYearNumeric = getYearNumeric;
/**
 * Returns a two-digit string representation of the year: 00, 01, ..., 99
 * @hidden
 */
var getYearTwoDigit = function (params) {
    var year = exports.getYearNumeric(params);
    return pad_number_to_length_1.padNumberToLength(year % 100, 2);
};
exports.getYearTwoDigit = getYearTwoDigit;
/**
 * Returns a four-digit string representation of the ISO week-numbering year: 1900, 1901, ..., 2099
 * @hidden
 */
var getWeekNumberingYearNumeric = function (_a) {
    var offsetUtcDate = _a.offsetUtcDate;
    var year = offsetUtcDate.getUTCFullYear();
    var month = offsetUtcDate.getUTCMonth() + 1;
    var day = offsetUtcDate.getUTCDate();
    var weekValues = get_iso_week_values_1.getIsoWeekValues(year, month, day);
    return pad_number_to_length_1.padNumberToLength(weekValues.weekYear, 4);
};
exports.getWeekNumberingYearNumeric = getWeekNumberingYearNumeric;
/**
 * Returns a two-digit string representation of the ISO week-numbering year: 00, 01, ..., 99
 * @hidden
 */
var getWeekNumberingYearTwoDigit = function (params) {
    var weekYear = exports.getWeekNumberingYearNumeric(params);
    return weekYear.substr(2, 2);
};
exports.getWeekNumberingYearTwoDigit = getWeekNumberingYearTwoDigit;
//# sourceMappingURL=year.js.map